import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiSettings, FiMaximize2, FiSun, FiTarget, FiActivity } = FiIcons;

const ConversionSettings = ({ settings, onSettingsChange }) => {
  const handleSettingChange = (key, value) => {
    onSettingsChange(prev => ({ ...prev, [key]: value }));
  };

  const presets = [
    { name: '1 Plaque', w: 29, h: 29 },
    { name: '4 Plaques (Carré)', w: 58, h: 58 },
    { name: '6 Plaques (Portrait)', w: 58, h: 87 },
    { name: '9 Plaques (Grand)', w: 87, h: 87 }
  ];

  return (
    <motion.div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-200 space-y-6">
      <div className="flex items-center justify-between border-b pb-4">
        <h2 className="text-lg font-bold flex items-center">
          <SafeIcon icon={FiSettings} className="mr-2 text-purple-600" />
          Réglages Studio
        </h2>
      </div>

      <div className="space-y-3">
        <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Format du projet</label>
        <div className="grid grid-cols-2 gap-2">
          {presets.map((p, i) => (
            <button
              key={i}
              onClick={() => { handleSettingChange('width', p.w); handleSettingChange('height', p.h); }}
              className={`p-2 text-[11px] font-bold rounded-lg border-2 transition-all ${settings.width === p.w ? 'border-purple-600 bg-purple-50' : 'border-slate-100 hover:border-slate-300'}`}
            >
              {p.name}
            </button>
          ))}
        </div>
      </div>

      <div className="space-y-4 pt-4">
        <div className="space-y-3">
          <div className="flex justify-between items-center">
            <span className="text-xs font-bold flex items-center"><SafeIcon icon={FiTarget} className="mr-1" /> Contraste</span>
            <span className="text-xs font-mono bg-slate-100 px-2 rounded">{settings.contrast}</span>
          </div>
          <input type="range" min="0" max="100" value={settings.contrast} onChange={(e) => handleSettingChange('contrast', parseInt(e.target.value))} className="w-full h-1.5 bg-slate-200 rounded-lg appearance-none accent-purple-600 cursor-pointer" />
        </div>

        <div className="space-y-3">
          <div className="flex justify-between items-center">
            <span className="text-xs font-bold flex items-center"><SafeIcon icon={FiSun} className="mr-1" /> Saturation</span>
            <span className="text-xs font-mono bg-slate-100 px-2 rounded">{settings.saturation.toFixed(1)}</span>
          </div>
          <input type="range" min="0" max="3" step="0.1" value={settings.saturation} onChange={(e) => handleSettingChange('saturation', parseFloat(e.target.value))} className="w-full h-1.5 bg-slate-200 rounded-lg appearance-none accent-purple-600 cursor-pointer" />
        </div>

        <div className="space-y-3">
          <div className="flex justify-between items-center">
            <span className="text-xs font-bold flex items-center"><SafeIcon icon={FiActivity} className="mr-1" /> Gamma</span>
            <span className="text-xs font-mono bg-slate-100 px-2 rounded">{settings.gamma.toFixed(1)}</span>
          </div>
          <input type="range" min="0.5" max="2.5" step="0.1" value={settings.gamma} onChange={(e) => handleSettingChange('gamma', parseFloat(e.target.value))} className="w-full h-1.5 bg-slate-200 rounded-lg appearance-none accent-purple-600 cursor-pointer" />
        </div>
      </div>

      <div className="pt-4 border-t space-y-3">
        <label className="flex items-center justify-between cursor-pointer group">
          <span className="text-xs font-bold group-hover:text-purple-600 transition-colors">Netteté intelligente</span>
          <input type="checkbox" checked={settings.sharpen} onChange={(e) => handleSettingChange('sharpen', e.target.checked)} className="w-4 h-4 accent-purple-600" />
        </label>
        <label className="flex items-center justify-between cursor-pointer group">
          <span className="text-xs font-bold group-hover:text-purple-600 transition-colors">Diffusion d'erreur</span>
          <input type="checkbox" checked={settings.useDithering} onChange={(e) => handleSettingChange('useDithering', e.target.checked)} className="w-4 h-4 accent-purple-600" />
        </label>
      </div>
    </motion.div>
  );
};

export default ConversionSettings;